import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Hero from "../components/Hero";
import BenefitCard from "../components/BenefitCard";
import ContactSection from "../components/ContactSection";

const HomePage = () => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: "🏆",
      title: "Authentic Classics",
      description: "Carefully curated and restored vintage automobiles",
    },
    {
      icon: "🔧",
      title: "Expert Restoration",
      description: "Master craftsmen with decades of experience",
    },
    {
      icon: "📜",
      title: "Documented History",
      description: "Complete provenance and authenticity records",
    },
    {
      icon: "⭐",
      title: "Premium Service",
      description: "White-glove treatment for discerning collectors",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "var(--bg-dark)" }}>
      <Hero onExploreClick={() => navigate("/catalogue")} />

      {/* Benefits Section */}
      <motion.div
        className="container-fluid py-5"
        style={{
          background: "var(--bg-surface)",
          borderTop: "1px solid var(--glass-border)",
        }}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >
        <div className="container py-5">
          <motion.div className="text-center mb-5" variants={itemVariants}>
            <h2 className="display-4 mb-3">The Vintage Experience</h2>
            <div style={{ width: "60px", height: "3px", background: "var(--highlight-gold)", margin: "0 auto" }}></div>
          </motion.div>

          <div className="row g-4">
            {benefits.map((benefit, index) => (
              <motion.div key={index} className="col-12 col-md-6 col-lg-3" variants={itemVariants}>
                <BenefitCard
                  icon={benefit.icon}
                  title={benefit.title}
                  description={benefit.description}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>

      {/* Stats Section */}
      <motion.div
        className="py-5 position-relative"
        style={{
          // New background image: Vintage car detail (Dashboard/Interior)
          background: "linear-gradient(rgba(15, 17, 21, 0.9), rgba(15, 17, 21, 0.8)), url('https://images.unsplash.com/photo-1485291571150-772bcfc10da5?q=80&w=2670&auto=format&fit=crop')",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          backgroundPosition: "center"
        }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="container py-5">
          <div className="row g-5 text-center text-white">
            <div className="col-12 col-md-4">
              <h2
                className="display-3 fw-bold mb-2"
                style={{ color: "var(--highlight-gold)", fontFamily: "var(--font-heading)" }}>
                500+
              </h2>
              <p className="fs-5 text-uppercase letter-spacing-2 text-white">Classics Restored</p>
            </div>
            <div className="col-12 col-md-4">
              <h2
                className="display-3 fw-bold mb-2"
                style={{ color: "var(--highlight-gold)", fontFamily: "var(--font-heading)" }}>
                50+
              </h2>
              <p className="fs-5 text-uppercase letter-spacing-2 text-white">Years Experience</p>
            </div>
            <div className="col-12 col-md-4">
              <h2
                className="display-3 fw-bold mb-2"
                style={{ color: "var(--highlight-gold)", fontFamily: "var(--font-heading)" }}>
                100%
              </h2>
              <p className="fs-5 text-uppercase letter-spacing-2 text-white">Client Satisfaction</p>
            </div>
          </div>
        </div>
      </motion.div>

      <ContactSection />
    </div>
  );
};

export default HomePage;
